export const getUserLocale = () => {
	return Intl.DateTimeFormat().resolvedOptions().locale;
};
